import type { ContentWatchedEligibility } from './index.h'

import { MediaTypes } from '@setplex/tria-api'

const ELIGIBLE_CONTENT_TYPES = new Set<string>([
  MediaTypes.VOD,
  MediaTypes.EPISODE,
])

export const isContentWatchedEligible = ({
  contentType,
  guest,
  partner,
  blockedByAcl,
  locked,
  hasPlaybackAccess = true,
}: ContentWatchedEligibility): boolean => {
  if (!contentType || !ELIGIBLE_CONTENT_TYPES.has(String(contentType))) {
    return false
  }

  if (guest || partner || blockedByAcl || locked) {
    return false
  }

  return hasPlaybackAccess
}
